const FreteNoProdutoIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      id="Camada_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 3000 3000"
    >
      <style type="text/css">
        {
          ".st0{fill:#080413;}.st1{fill:#FDFDFD;}.st2{fill:#00CFFE;}.st3{fill:#0097FE;}.st4{fill:#FFFFFF;}"
        }
      </style>
      <g>
        <g>
          <path
            className="st0"
            d="M536.1,688.2c-11.7-28-31.3-103.8-29.4-187.2c3.6-160.3,17.6-191.7,29.4-224.6c23.7-66.3,50.6-61.2,105.2-43
			c99.3,33.1,139.6,36.4,228.1,110.9c29.9,25.2,66.1,83.6,84.5,157.3c1.9,7.7,10,12.1,17.5,9.5c56.4-19.4,113.4-36.6,172.3-46
			c94.4-15.1,189.7-32.1,285-18.1c107.9,15.9,192.6,43.4,281,107c39,28.1,92.2,93.2,120,131.4c80.5,110.7,133.9,224.5,218.5,332.5
			c48.7,62.2,171.3,171.5,206.1,195.7c52,36.2,41.7,27.5,127.8-53.4c34.5-32.5,109.7-82.8,123-88c46.3-18.3,52.2-30.4,81.8,8.8
			c20.8,27.6,71.9,108,96.6,149.8c75.5,127.3,106.1,194.5,145.6,338c34.7,125.9,35.4,296.4,26.9,426.7
			c-15.6,240.5-82.7,390.5-231.5,571.8c-75.9,92.4-219.9,197-330.6,238.1c-173.4,64.4-351.8,102.2-537.5,93.2
			c-311.2-15.2-590.3-118.3-840.2-306c-255.3-191.8-415-446.2-509.1-746.8c0,0,105.3,56.5,151,65.2c73.2,14,141.6-7.8,200.3-49.4
			c9.6-6.8,20.2-17.8,29.1-25.6c67.2-72.1,113.5-157.5,143.3-250.8c26-81.4,28.2-166.5,8.3-248.6c-16.3-67.2-51.4-132.6-85.9-192
			C775.4,1011.2,536.1,688.2,536.1,688.2z"
          />
          <path
            className="st0"
            d="M1881.3,283.1c2.4,58.7-1.6,86.3-12.2,145.5c-4.3,27.5-25.5,89-38.7,102.6c-12.4,12.8-29.9,13.2-45.3,4.9
			c-83.2-66.7-222.3-126.4-318.4-141.1c-20.4-8.5-17-19-14-41.1c9.3-67.4,74.5-150.2,135.3-187.2c70.9-43.2,120.2-58.9,196.3-65.9
			c39.4-3.7,63.4,3.8,72.9,41.5C1871.7,199.3,1876.6,229.4,1881.3,283.1z"
          />
          <path
            className="st1"
            d="M2160.4,2295.5c-35.4,0.6-56.1-26.3-46.8-60.8c12.2-45.1,86.6-106.5,133.1-109.7c36-2.5,58.6,22.5,51.5,57
			C2288.6,2229.1,2209,2294.7,2160.4,2295.5z"
          />
          <path
            className="st0"
            d="M1376.5,1674.8c-2,39.4-8.2,74.2-30.3,104.1c-30.3,41.2-74.3,53-118.7,27.4
			c-76.6-44.3-101.4-116.7-100.6-200.5c0.3-31.7,8.5-62.1,27-88.8c31-44.7,77.3-56.2,124.4-28.9c58.9,34.2,84.7,90,95.3,154.6
			C1375.7,1654.4,1375.8,1666.3,1376.5,1674.8z"
          />
        </g>
        <g>
          <path
            className="st2"
            d="M886.9,1205.7C792.8,1027.7,541.2,695,536.1,688.2c-71.7-96.3-145.9-190.7-223.9-282.1
			c-16.4-19.3-47.7-55.6-74.7-54.3c-7.1-0.6-13.4,0.5-19,3L789,1834.4c90.1-96.3,143.6-210.8,160.6-340.9
			C962.8,1391.1,934.8,1296.3,886.9,1205.7z"
          />
          <path
            className="st3"
            d="M180,404.4c-18.1,41.3-26.6,85.1-32.9,129.5c-29.6,209.7,35,349,35,349c-23.9,85.3-42.7,261.5-3.2,382
			c25.5,77.7,65.8,169.9,65.8,169.9c-3.7,16.5-11,53.5-11.9,70.2c-11.4,222.3,155.9,324.6,174.5,340.6c28.4,14.7,56.2,30.5,85.2,44
			c102.8,48,214.2,27.4,295.1-53.7c0.5-0.5,1-1.1,1.5-1.6L218.5,354.7C201.5,362.1,190,381.5,180,404.4z"
          />
        </g>

        <ellipse
          transform="matrix(0.9723 -0.2338 0.2338 0.9723 -355.2238 336.2822)"
          className="st4"
          cx="1240.8"
          cy="1666.5"
          rx="203.4"
          ry="265.6"
        />
        <ellipse
          transform="matrix(0.9723 -0.2338 0.2338 0.9723 -354.8778 336.1694)"
          cx="1240.5"
          cy="1664.9"
          rx="126.8"
          ry="165.7"
        />
      </g>
    </svg>
  );
};

export default FreteNoProdutoIcon;
